import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Carousel from "react-bootstrap/Carousel"

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { relativeDirectory: { eq: "header-bg" } }) {
        edges {
          node {
            publicURL
          }
        }
      }
    }
  `)
  const edges = data.allFile.edges
  return (
    <header>
      <Carousel
        interval={10000}
        fade={true}
        controls={false}
        indicators={true}
        pause={false}
      >
        {edges.map(({ node }, index) => {
          return (
            <Carousel.Item key={index}>
              <img src={node.publicURL} alt="Paysage" />
              <Carousel.Caption>
                <h1>
                  <span className="title">{siteTitle}</span>
                  <br />
                  {/* <span className="subtitle">
                    Vous guider sur le chemin de la respiration et du mieux-être
                  </span> */}
                </h1>
              </Carousel.Caption>
            </Carousel.Item>
          )
        })}
      </Carousel>
    </header>
  )
}

export default Header
